import React, { useState, useContext } from "react";
import axios from "../../../../axios/index";

import { UserContext } from "../../../Context/UserContextProvider";

// components
import Modal from "react-bootstrap/Modal";
import ReminderPortalDatePicker from "../../Notes/Reminder/ReminderPortalDatePicker";
import ReminderTimePicker from "../../Notes/Reminder/ReminderTimePicker";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// styles
import ModalStyles from "../../DashboardReuseAbleComponents/Modal.module.css";
import styles from "../../Notes/Reminder/ReminderPortal.module.css";

export default function AddCallModal(props) {
  const { userToken } = useContext(UserContext);
  const [btnLoader, setBtnLoader] = React.useState(false);
  const [error, setError] = useState(false);
  const [callData, setCallData] = useState({
    phoneNumber: "",
    callerName: "",
    callDate: "",
    callTime: "",
  });

  return (
    <>
      <style type="text/css">
        {`
                .modal {
                    background: #3335 !important;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                    min-height: 517px;
                }

                .modal-header {
                    align-items: center !important;
                }

                .rmdp-container {
                    width: 370px;
                    height: 48px !important;
                    background: #F9F9F9;
                    border: 1px solid #E1E1E1;
                    border-radius: 24px;
                    display: flex !important;
                    align-items: center;
                    justify-content: start;
                    padding-right: 27px;
                    cursor: pointer;
                }
    
                .rmdp-wrapper {
                    width: 370px;
                    background: #FFFFFF !important;
                    border: 1px solid #E1E1E1 !important;
                    border-radius: 24px !important;
                    box-shadow: none !important;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .rmdp-input,
                .rmdp-input:focus {
                    width: 100%;
                    background: transparent;
                    border: none !important;
                    cursor: pointer !important;
                    box-shadow: none !important;
                }

                rmdp-top-class {
                    display: flex;
                    width: 100%;
                    align-items: center;
                    justify-content: center;
                }
                
                .rmdp-calendar {
                    width: 100%;
                }
                
                .rmdp-day-picker {
                    justify-content: center;
                }
                
                .rmdp-week, .rmdp-ym {
                    width: 370px;
                    padding: 0 27px;
                }

                @media only screen and (max-width: 765.98px) {
                    .rmdp-week, .rmdp-ym,.rmdp-container,
                    .rmdp-wrapper  {
                        width: 290px !important;
                    }

                    .modal-content {
                        width: 350px;
                    }
                  }
            `}
      </style>

      <ToastContainer
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton dir="rtl">
          <div className="w-100 d-flex align-items-start justify-content-between px-3">
            <div className={ModalStyles.title}>ثبت تماس جدید</div>
          </div>
        </Modal.Header>
        <Modal.Body dir="rtl">
          <div className="w-100 d-flex flex-column align-items-center justify-content-center py-2 flex-wrap">
            <div className={`w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap pt-0 px-2 mb-4`}>
              <div className={`d-flex align-items-start justify-content-center flex-column my-3 ${styles.input_container1}`}>
                <div className={`mb-3 ${styles.input_top_title}`}>شماره</div>
                <input className={styles.input} type="text" name="phoneNumber" value={callData.phoneNumber} onChange={changeHandler} />
              </div>
              <div className={`d-flex align-items-start justify-content-center flex-column my-3 ${styles.input_container1}`}>
                <div className={`mb-3 ${styles.input_top_title}`}>نام نام خانوادگی گیرنده تماس</div>
                <input className={styles.input} type="text" name="callerName" value={callData.callerName} onChange={changeHandler} />
              </div>
            </div>
            <div className={`w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap pt-0 px-2 mb-2`}>
              <ReminderPortalDatePicker data={callData.callDate} setData={setCallData} addCall />

              <ReminderTimePicker data={callData.callTime} setData={setCallData} addCall />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 flex-column d-flex justify-content-center align-items-center mb-3">
            {btnLoader ? (
              <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`}>
                <div className={ModalStyles.btn_loader_container}>
                  <div className={ModalStyles.btn_spinner}></div>
                </div>
              </div>
            ) : (
              <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`} onClick={clickHandler}>
                دخیره
              </div>
            )}
            {error && <span className="text-danger mt-4">لطفا تمام فیلد هارا پر کنید!</span>}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );

  function changeHandler(event) {
    setCallData(prev => {
      return { ...prev, [event.target.name]: event.target.value };
    });
  }

  async function clickHandler() {
    if ((callData.phoneNumber === "") | (callData.callerName === "") | (callData.callDate == "") | (callData.callTime == "")) {
      setError(true);
    } else {
      try {
        setBtnLoader(true);
        const date = `${callData.callDate.year}/${callData.callDate.month.number}/${callData.callDate.day}`;
        const time = `${callData.callDate.hour}:${callData.callDate.minute}`;

        var data = new FormData();
        data.append("UserId", props.UserId[0]);
        data.append("EstateId", props.EstateId);
        data.append("PhoneNumber", callData.phoneNumber);
        data.append("CallerName", callData.callerName);
        data.append("CallDate", date);
        data.append("CallTime", time);

        const apiData = await axios.post("ReportCall", data, {
          headers: { authorization: "Bearer " + userToken },
        });
        // console.log(apiData.data.isSuccess)
        if (apiData.data.isSuccess) {
          notify("تماس شما با موفقیت ثبت شد", "success");
        } else {
          notify("خطایی رخ داد لطفا بعد چند دقیقه دوباره امتحان نمایید", "success");
        }
      } catch (error) {
        // console.log(error);
        notify("خطایی رخ داد لطفا بعد چند دقیقه دوباره امتحان نمایید", "success");
      } finally {
        setBtnLoader(false);
        props.onHide();
        window.location.reload(false);
      }
    }
  }

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }
}
